import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {KeycloakService} from 'keycloak-angular';

const endpoint = environment.apiUrl;
const defaultVersion = environment.apiVersionDefault;

@Injectable()
export class ApiClhubService {

    constructor(private keycloakService: KeycloakService, private httpClient: HttpClient) {
    }

    public get(methodApi: string, apiVersion: string = null): Observable<any> {
        const headers = new HttpHeaders()
            .set('Access-Control-Allow-Origin', '*')
            .set('Content-Type',  'application/json');
        this.keycloakService.addTokenToHeader(headers);

        if (apiVersion == null) {
            apiVersion = defaultVersion;
        }
        return this.httpClient.get(endpoint + apiVersion + '/' +  methodApi, {headers});
    }

    public post(methodApi: string, body: any | null, apiVersion: string = null): Observable<any> {
      const headers = new HttpHeaders()
        .set('Access-Control-Allow-Origin', '*')
        .set('Content-Type',  'application/json');
      this.keycloakService.addTokenToHeader(headers);

      if (apiVersion == null) {
          apiVersion = defaultVersion;
      }
       return this.httpClient.post(endpoint + apiVersion + '/' + methodApi, body, {headers});
    }

    public put(methodApi: string, body: any | null, apiVersion: string = null): Observable<any> {
      const headers = new HttpHeaders()
        .set('Access-Control-Allow-Origin', '*')
        .set('Content-Type',  'application/json');
      this.keycloakService.addTokenToHeader(headers);

      if (apiVersion == null) {
        apiVersion = defaultVersion;
      }

      return this.httpClient.put(endpoint + apiVersion + '/' + methodApi, body, {headers});
    }

    public delete(methodApi: string, params: any | null, apiVersion: string = null): Observable<any> {
      const headers = new HttpHeaders()
        .set('Access-Control-Allow-Origin', '*')
        .set('Content-Type',  'application/json');
      this.keycloakService.addTokenToHeader(headers);

      if (apiVersion == null) {
        apiVersion = defaultVersion;
      }

    return this.httpClient.delete(endpoint + apiVersion + '/' + methodApi, {headers, params});
  }
}
